export default function TargetCustomers() {
  const customers = [
    {
      icon: 'ri-home-4-line',
      title: 'Homeowners',
      description: 'Enhance curb appeal, eliminate safety hazards, and reclaim valuable yard space for landscaping, play areas, or outdoor living. Professional stump grinding protects your family from tripping hazards while preventing pest infestations that could threaten your home.'
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial Property Managers',
      description: 'Maintain professional appearances, reduce liability risks, and ensure safe premises for tenants and visitors. Stump removal prevents costly accidents, improves property value, and creates clean, attractive landscapes that enhance your business reputation.'
    },
    {
      icon: 'ri-store-2-line',
      title: 'Real Estate Professionals',
      description: 'Maximize property value and accelerate sales by eliminating unsightly stumps that deter potential buyers. Professional stump grinding transforms listings, improves first impressions, and helps properties photograph better for marketing materials.'
    },
    {
      icon: 'ri-government-line',
      title: 'HOA & Community Associations',
      description: 'Maintain neighborhood standards, preserve common area aesthetics, and ensure resident safety. Stump grinding keeps community spaces attractive, prevents liability issues, and upholds property values throughout the neighborhood.'
    },
    {
      icon: 'ri-landscape-line',
      title: 'Landscape Contractors',
      description: 'Prepare sites for new installations, clear obstacles for mowing and maintenance, and deliver complete property transformations. Partner with professional stump grinding services to offer comprehensive solutions and exceed client expectations.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-emerald-100 text-emerald-700 text-xs font-semibold rounded-full mb-4">
            OUR CLIENTS
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Who Benefits from Professional Stump Removal?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From residential properties to commercial developments, our expert stump grinding services help diverse property owners across Atlanta solve landscape challenges and enhance their outdoor spaces
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {customers.map((customer, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200 hover:border-emerald-300 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${customer.icon} text-white text-3xl`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {customer.title}
              </h3>
              
              <p className="text-sm text-gray-700 leading-relaxed">
                {customer.description}
              </p>
            </div>
          ))}

          <div className="bg-gradient-to-br from-emerald-600 to-emerald-700 p-8 rounded-2xl text-white flex flex-col justify-center items-center text-center hover:shadow-xl transition-all duration-300">
            <i className="ri-question-line text-5xl mb-4 opacity-90"></i>
            <h3 className="text-2xl font-bold mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
              Not Sure If We Can Help?
            </h3>
            <p className="text-emerald-100 text-sm mb-6 leading-relaxed">
              Every property is unique. Contact us to discuss your specific stump removal needs and get expert advice.
            </p>
            <a 
              href="#contact"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-emerald-600 font-bold text-sm rounded-xl hover:bg-emerald-50 transition-all whitespace-nowrap cursor-pointer"
            >
              Get Free Consultation
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
